import { ConfirmModal, Toasts, useModalContext } from '@fourthwall/components';
import { routing } from '@utils/routing';
import logoSrc from '../../../assets/signets/zapier.svg';
import { useAppConnectEvent } from '../../../hooks/useAppConnectEvent';
import { useAppConnectedEvent } from '../../../hooks/useAppConnectedEvent';
import { useDisconnectPlatformAppMutation } from '../../../queries/useDisconnectPlatformAppMutation';
import { usePlatformAppQuery } from '../../../queries/usePlatformAppQuery';
export const useZapier = () => {
    const { platformAppQuery: { data: zapierApp, refetch, isLoading }, } = usePlatformAppQuery([{ appId: 'apps.zapier' }]);
    const { open } = useModalContext();
    const appConnectEvent = useAppConnectEvent('zapier');
    const { disconnectPlatformAppMutation: disconnectZapierMutation } = useDisconnectPlatformAppMutation('apps.zapier');
    useAppConnectedEvent('zapier');
    const getStatus = () => {
        if (!zapierApp)
            return undefined;
        if (zapierApp.state === 'UNINSTALLED' || zapierApp.state === 'NEEDS_RECONNECT')
            return 'NOT_CONNECTED';
        if (zapierApp.state === 'INSTALLED')
            return 'CONNECTED';
    };
    const status = getStatus();
    const getConnectBar = () => {
        const connectBarBase = {
            logoSrc,
            description: status === 'CONNECTED' ? 'Connected to Zapier' : 'Connect to Fourthwall on Zapier',
            disabled: false,
        };
        if (!status)
            return undefined;
        if (status === 'NOT_CONNECTED') {
            if (!zapierApp)
                return;
            const onConnect = () => {
                appConnectEvent.trigger();
                window.open(routing.external.zapier.createZap, '_blank');
            };
            return {
                ...connectBarBase,
                onConnect,
            };
        }
        if (status === 'CONNECTED') {
            const onDisconnect = () => {
                open(ConfirmModal, {
                    title: 'Are you sure you want to disconnect from Zapier?',
                    confirmLabel: 'Yes, disconnect',
                    confirmAppearance: 'destructive',
                    onConfirm: () => {
                        const toastId = 'disconnectZapierMutation';
                        Toasts.notify('Disconnecting from Zapier...', {
                            toastId,
                            type: 'info',
                            autoClose: false,
                        });
                        disconnectZapierMutation.mutate(undefined, {
                            onSuccess: () => {
                                refetch();
                                Toasts.notify('Disconnected from Zapier successfully.', { type: 'success' });
                                Toasts.dismiss(toastId);
                            },
                        });
                    },
                });
            };
            return {
                ...connectBarBase,
                disabled: disconnectZapierMutation.isLoading,
                onDisconnect,
            };
        }
    };
    return {
        connectBar: getConnectBar(),
        status,
        isLoading,
    };
};
